module.exports = __webpack_public_path__ + "img/start.c961faee.svg";